import * as ActionBase from "DistributedTaskControls/Common/Actions/Base";

import { CreateReleaseVersionPickerKeys } from "PipelineWorkflow/Scripts/SharedComponents/CreateRelease/Constants";

import * as PipelineTypes from "PipelineWorkflow/Scripts/Common/Types";

export class BuildVersionPickerActions extends ActionBase.ActionsHubBase {
    public static getKey(): string {
        return CreateReleaseVersionPickerKeys.ActionHubKey_BuildVersionPickerActionHub;
    }

    public initialize(): void {
        this._setBuildVersions = new ActionBase.Action<PipelineTypes.IArtifactVersion[]>();
        this._setRepositoryId = new ActionBase.Action<string>();
        this._setSelectedBranch = new ActionBase.Action<string>();
        this._setSelectedBuildVersion = new ActionBase.Action<PipelineTypes.IArtifactVersion>();
    }

    public get setBuildVersions(): ActionBase.Action<PipelineTypes.IArtifactVersion[]> {
        return this._setBuildVersions;
    }
  
    public get setRepositoryId(): ActionBase.Action<string> {
        return this._setRepositoryId;
    }
  
    public get setSelectedBranch(): ActionBase.Action<string> {
        return this._setSelectedBranch;
    }
  
    public get setSelectedBuildVersion(): ActionBase.Action<PipelineTypes.IArtifactVersion> {
        return this._setSelectedBuildVersion;
    }
  
    private _setBuildVersions: ActionBase.Action<PipelineTypes.IArtifactVersion[]>; 
    private _setRepositoryId: ActionBase.Action<string>; 
    private _setSelectedBranch: ActionBase.Action<string>; 
    private _setSelectedBuildVersion: ActionBase.Action<PipelineTypes.IArtifactVersion>; 
}